import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import placementService from "./placementService";

export const getPlacementList = createAsyncThunk(
  "placementList/get-placementList",
  async (thunkAPI) => {
    try {
      return await placementService.getPlacementList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPlacementReportList = createAsyncThunk(
  "placementReportList/get-placementReportList",
  async (thunkAPI) => {
    try {
      return await placementService.getPlacementReportList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getNewPlacementList = createAsyncThunk(
  "newPlacementList/get-newPlacementList",
  async (thunkAPI)=>{
    try {
      return await placementService.getNewPlacementList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

export const resetState = createAction("Reset_all");

const initialState = {
  placementLists: [],
  placementreportList:[],
  placements:[],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const placementListSlice = createSlice({
  name: "placementList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlacementList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPlacementList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.placementLists = action.payload;
      })
      .addCase(getPlacementList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getPlacementReportList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPlacementReportList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.placementreportList = action.payload;
      })
      .addCase(getPlacementReportList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getNewPlacementList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNewPlacementList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.placements = action.payload;
      })
      .addCase(getNewPlacementList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default placementListSlice.reducer;
